import { MenuItem, Select as MuiSelect } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import PropTypes from 'prop-types'
import { useController, useFormContext } from 'react-hook-form'

import { styles } from './../table.styles'

const TablePaginationSelect = ({ name, options }) => {
  const { control, register } = useFormContext()
  const {
    field: { value, onChange },
  } = useController({
    register,
    control,
    name,
  })

  return (
    <MuiSelect
      test-id={'pagination-select'}
      onChange={onChange}
      value={value}
      IconComponent={ExpandMoreIcon}
      sx={styles.paginationSelect.root}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          test-id={`pagination-select-value-${option.value}`}
        >
          {option.label}
        </MenuItem>
      ))}
    </MuiSelect>
  )
}

TablePaginationSelect.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default TablePaginationSelect
